<template>
  <MetricCard
    apiEndpoint="/instagram/profile-views"
    metricName="PROFILE VIEWS"
    :formatData="formatData"
    srcName="Instagram"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import MetricCard from '@/components/MetricCard.vue';
const formatData = (data) => formatNumber(data.data);
</script>
